import Tooltip from "@mui/material/Tooltip";

const columns = [
  {
    name: "Name",
    selector: "name",
    sortable: true,
    minWidth: "140px",
    cell: (row) => {
      return (
        <Tooltip
          classes={{
            tooltip: "multiline-tooltip",
          }}
          title={row.name}
        >
          <div className="two-line-content">
            {row.name}
          </div>
        </Tooltip>
      );
    },
  },
  {
    name: "Description",
    selector: "description",
    sortable: true,
    cell: (row) => {
      return (
        <Tooltip
          classes={{
            tooltip: "multiline-tooltip",
          }}
          title={row.description}
        >
          <div className="two-line-content">
            {row.description}
          </div>
        </Tooltip>
      );
    },
    minWidth: "200px",
  },
  {
    name: "Category",
    selector: "category.name",
    sortable: true,
    width: "130px",
    cell: (row) => {
      return (
        <Tooltip
          classes={{
            tooltip: "multiline-tooltip",
          }}
          title={row.category?.name || '-'}
        >
          <div className="two-line-content">
            {row.category?.name || '-'}
          </div>
        </Tooltip>
      );
    },
  },
  {
    name: "Subcategory",
    selector: "subCategory.name",
    sortable: true,
    width: "130px",
    cell: (row) => {
      return (
        <Tooltip
          classes={{
            tooltip: "multiline-tooltip",
          }}
          title={row.subCategory?.name || '-'}
        >
          <div className="two-line-content">
            {row.subCategory?.name || '-'}
          </div>
        </Tooltip>
      );
    },
  },
  {
    name: "Dietary Tags",
    selector: "tags.0.name",
    sortable: true,
    width: "170px",
    cell: (row) => {
      if (!row.tags?.length) {
        return "-";
      }

      return (
        <Tooltip
          classes={{
            tooltip: "multiline-tooltip",
          }}
          title={row.tags.map(tag => tag.name).join(", ")}
        >
          <div className="two-line-content">
            {row.tags.map(tag => tag.name).join(", ")}
          </div>
        </Tooltip>
      );
    },
  },
  {
    name: "Servings",
    selector: "servings",
    sortable: true,
    width: "160px",
    cell: (row) => {
      return (
        <Tooltip
          classes={{
            tooltip: "multiline-tooltip",
          }}
          title={row.servings}
        >
          <div className="two-line-content">
            {row.servings}
          </div>
        </Tooltip>
      );
    },
  },
  {
    name: "Sort Order",
    selector: "order",
    sortable: true,
    width: "120px",
    cell: (row) => {
      return (
        <Tooltip
          classes={{
            tooltip: "multiline-tooltip",
          }}
          title={row.order}
        >
          <div className="two-line-content">
            {row.order}
          </div>
        </Tooltip>
      );
    },
  },
];

export { columns };
